import { observeState } from 'lit-element-state'
import store from './store/index.js'
import router from './router/store.js'
import { css } from 'lit'
import baseStyles from '../lib/styles/base.js'
import HHElement from '../element.js'

/**
 * Global app mixin for components
 * - Adds store and router states to component
 * - Implements observeState to component
 */

export default class HHQuizElement extends observeState(HHElement) {
  constructor() {
    super()
    this.store = store
    this.router = router
  }

  static mq = {
    xs: 720,
    sm: 910,
    md: 1100,
    lg: 1200,
    xl: 1400,
    '2xl': 1500,
    '3xl': 1800,
  }

  hydrateText(text) {
    const keywords = {
      name: this.store.customer?.name,
    }
    return Object.keys(keywords).reduce((t, key) => {
      const value = keywords[key] ?? ''
      return t.replaceAll(`{{ ${key} }}`, value).replaceAll(`{{${key}}}`, value)
    }, `${text}`)
  }

  /**
   * Focuses the first focusable element
   */
  focusFirstWithin(selectors = [".focus-first"]) {
    clearTimeout(this.focusFirstWithinTimeout)
    this.focusFirstWithinTimeout = setTimeout(() => {
      selectors.some(selector => {
        const el = this.querySelector(selector)
        if (el) { 
          el.focus()
          return true
        }
        return false;
      })
    }, 1)
  }

  static styles = [baseStyles, css`
    .only-mobile {
      display: none;
    }

    @media screen and (max-width: ${HHQuizElement.mq.xs}px) {
      .only-mobile {
        display: block;
      }
      .only-desktop {
        display: none;
      }
    }
  `]
}
